import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Body } from 'components/Text'

import BaseFundComponent from './BaseFundComponent'

const FundTab: FC = () => {
	const { t } = useTranslation()

	return (
		<section>
			<FundTitle>{t('futures.one-click-trading.onboard.fund-title')}</FundTitle>
			<BaseFundComponent />
		</section>
	)
}

const FundTitle = styled(Body)`
	margin: 0 0 10px 0;
	color: ${(props) => props.theme.colors.selectedTheme.text.label};
`

export default FundTab
